import { createContext, Dispatch, SetStateAction } from 'react';

export type BreadcrumbsContextType = {
  titles: Record<string, string>;
  setTitles: Dispatch<SetStateAction<Record<string, string>>>;
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | null>(
  null,
);
